"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTransportMessage = isTransportMessage;

function isTransportMessage(m) {
  switch (m.type) {
    case 'request':
    case 'response':
    case 'error':
    case 'handler_unregistered':
    case 'handler_registered':
    case 'event_list':
      return true;

    default:
      return false;
  }
}